import { useState, useRef } from 'react'

import { Row, TextMyPlan, ContainerDownloadResults } from '../../pages/Home/styled'
import DownloadIcon from 'assets/icons/DownloadIcon'
import DevelopmentPlanSchema from 'views/components/report/components/development-plan'
import { P } from 'views/components/UI/Text'
import { useNotification } from 'lib/context/notification.context'
import { useTranslation } from 'react-i18next'
import getDevelopmentPlan from 'services/pdfReports/getDevelopmentPlan'
import {
  closeReportWindow,
  createPendingReportWindow,
  openReportInWindow,
} from 'utils/openReportInNewTab'
const DownloadPlan = ({ skillParam, typeTest, processIdParam, setLoadingReport }: any) => {
  const { t } = useTranslation()
  const { getError, getSuccess } = useNotification()
  const [data] = useState<any>()
  const developmentPlanTemplateRef = useRef<HTMLDivElement>(null)

  const handleDownload = async () => {
    const reportWindow = createPendingReportWindow()

    try {
      setLoadingReport(true)
      const response = await getDevelopmentPlan(skillParam)

      const { url } = response

      await openReportInWindow(reportWindow, url)

      getSuccess(t('global.notifications.planGenerated'))
    } catch (error) {
      closeReportWindow(reportWindow)
      console.error('Error al descargar el plan de desarrollo:', error)
      getError('No fue posible abrir el plan de desarrollo.')
    } finally {
      setLoadingReport(false)
    }
  }

  return (
    <>
      <Row margin="30px 0px 10px 0px" width="100%" flexDirection="column" style={{ padding: '0px 10px' }}>
        <TextMyPlan>
          {t('evaluatedUser.developmentPlan.createdDevelopmentPlanTitle')}{' '}
          {typeTest === 'betesa' ? 'Betesa' : t('global.common.skillText')}
        </TextMyPlan>
        <Row style={{ cursor: 'pointer' }} width="100%" flexDirection="row" alignItems="center">
          <ContainerDownloadResults>
            <DownloadIcon />
            <P fontWeight={700} onClick={handleDownload} color="#2D749C" margin="0px 10px">
              {t('evaluatedUser.developmentPlan.downloadDevelopmentPlanButton')}
            </P>
          </ContainerDownloadResults>
        </Row>
      </Row>
      {data && (
        <div style={{ visibility: 'hidden', width: '595px', alignSelf: 'center', position: 'absolute', zIndex: '-1' }}>
          <div ref={developmentPlanTemplateRef}>
            <DevelopmentPlanSchema developmentPlan={data} type={typeTest} processId={processIdParam} />
          </div>
        </div>
      )}
    </>
  )
}

export default DownloadPlan
